import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {PageSettingsSchema} from './pageSettings'
import {PageSeoSchema} from './pageSeo'

export function buildPageSchemaForTemplate<Template extends z.ZodType>(templateSchema: Template) {
  return buildEntrySchemaFor('containerPage', {
    fields: z.lazy(() =>
      z.object({
        path: z.string(),
        settings: safeOptional(PageSettingsSchema),
        seo: safeOptional(PageSeoSchema),
        template: templateSchema,
        title: z.string(),
      }),
    ),
  })
}
